import {
  PollData_Poll_Settings_Permissions_ViewRole,
  PollData_Poll_Settings_Permissions_VoteRole
} from "./../../ricos-schema/legacy/wix/rich_content/v1";
const fromPollServer = (poll) => {
  return {
    id: poll.id,
    title: poll.title,
    createdBy: poll.createdBy,
    count: poll.count,
    anonymousCount: poll.anonymousCount,
    creatorFlag: poll.creatorFlag,
    ownVotes: poll.ownVotes,
    image: {
      src: {
        url: poll.mediaId
      }
    },
    options: poll.options.map(fromPollOption),
    settings: {
      permissions: {
        view: getViewRole(poll.settings.resultsVisibility),
        vote: getVoteRole(poll.settings.voteRole),
        allowMultipleVotes: poll.settings.multipleVotes
      },
      showVoters: poll.settings.votersDisplay,
      showVotesCount: poll.settings.votesDisplay
    }
  };
};
const fromPollOption = (option) => {
  return {
    id: option.id,
    title: option.title,
    image: {
      src: {
        url: option.mediaId
      }
    },
    count: option.count,
    anonymousCount: option.anonymousCount,
    rating: option.rating,
    latestVoters: option.latestVoters
  };
};
const getViewRole = (resultsVisibility) => {
  switch (resultsVisibility) {
    case "ALWAYS":
      return PollData_Poll_Settings_Permissions_ViewRole.EVERYONE;
    case "VOTERS_ONLY":
      return PollData_Poll_Settings_Permissions_ViewRole.VOTERS;
    default:
      return PollData_Poll_Settings_Permissions_ViewRole.CREATOR;
  }
};
const getVoteRole = (vote) => {
  switch (vote) {
    case "ALL":
      return PollData_Poll_Settings_Permissions_VoteRole.ALL;
    case "SITE_MEMBERS":
      return PollData_Poll_Settings_Permissions_VoteRole.SITE_MEMBERS;
    default:
      return PollData_Poll_Settings_Permissions_VoteRole.UNRECOGNIZED;
  }
};
export {
  fromPollServer
};
//# sourceMappingURL=fromPollServer.js.map
